export const schoolMockData = [
  {
    id: 1,
    schoolName: "مدارس النجاح ",
    schoolNameEn: "Al Najah School",
    description:
      "نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة",
    descriptionEn:
      "About the school About the school About the school About the school About the school",
    country: "السعودية",
    countryEn: "Saudi Arabia",
    city: "الرياض",
    cityEn: "Riyadh",
    district: "الرائد",
    districtEn: "Alraed",
    rating: 4.2,
    price: 12000,
    numberOfStudents: 2000,
    images: [
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
    ],
    educationSystem: "النظام الوطني السعودي",
    educationSystemEn: "Saudi National System",
    educationLevel: "كل المراحل",
    educationLevelEn: "All Levels",
    studentGender: "إناث",
    studentGenderEn: "Females",
    instagramAccount: "",
    xAccount: "",
    whatsapp: "",
    schoolFeatures: [
      "غرفة موسيقى",
      "النظام البريطاني",
      "كلا الجنسين",
      "منطقة مخصصة لإنزال واصطفاف الطلاب",
      "منطقة مخصصة لإنزال واصطفاف الطلاب",
      "مختبرات حاسوب للطلاب ",
      "كافتيريا أو منطقة توزيع الوجبات",
    ],
    schoolFeaturesEn: [
      "Music room",
      "British system",
      "Both gender",
      "An area designated for dropping off and queuing up students.",
      "An area designated for dropping off and queuing up students.",
      "Computer laboratories for students",
      "Cafeteria or meal distribution area",
    ],
    parentesReviwes: [
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
    ],
  },
  {
    id: 2,
    schoolName: "مدارس الظهران الأهلية",
    schoolNameEn: "Dhahran National Schools",
    description:
      "نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة",
    descriptionEn:
      "About the school About the school About the school About the school About the school",
    country: "السعودية",
    countryEn: "Saudi Arabia",
    city: "الظهران",
    cityEn: "Dahran",
    district: "الحي",
    districtEn: "District",
    rating: 5.0,
    price: 31000,
    numberOfStudents: 5000,
    images: [
      "/assets/images/school1main.jpeg",
      "/assets/images/school1a.jpeg",
      "/assets/images/school1b.jpeg",
      "/assets/images/school1c.webp",
      "/assets/images/school1d.jpeg",
    ],
    educationSystem: "النظام الأمريكي",
    educationSystemEn: "American system",
    educationLevel: "الروضة",
    educationLevelEn: "Kindergarten",
    studentGender: "كلاهما",
    studentGenderEn: "Both",
    instagramAccount: "",
    xAccount: "",
    whatsapp: "",
    schoolFeatures: ["غرفة موسيقى", "النظام البريطاني", "كلا الجنسين"],
    schoolFeaturesEn: ["Music room", "British System", "Both gender"],
    parentesReviwes: [
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
    ],
  },
  {
    id: 3,
    schoolName: "مدارس الفرسان العالمية",
    schoolNameEn: "Alforsan National Schools",
    description:
      "نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة",
    descriptionEn:
      "About the school About the school About the school About the school About the school",
    country: "السعودية",
    countryEn: "Saudi Arabia",
    city: "الرياض",
    cityEn: "Riyadh",
    district: "الحي",
    districtEn: "District",
    rating: 3.5,
    price: 23000,
    numberOfStudents: 2000,
    images: [
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
    ],
    educationSystem: "النظام الأمريكي",
    educationSystemEn: "American system",
    educationLevel: "الابتدائية",
    educationLevelEn: "Primary",
    studentGender: "إناث",
    studentGenderEn: "Females",
    instagramAccount: "",
    xAccount: "",
    whatsapp: "",
    parentesReviwes: [
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
    ],
    schoolFeatures: ["غرفة موسيقى", "النظام البريطاني"],
    schoolFeaturesEn: ["Music room", "British System"],
  },

  {
    id: 4,
    schoolName: "مدارس العالمية",
    schoolNameEn: "International Schools",
    description:
      "نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة",
    descriptionEn:
      "About the school About the school About the school About the school About the school",
    country: "السعودية",
    countryEn: "Saudi Arabia",
    city: "جدة",
    cityEn: "Jeddah",
    district: "الحي",
    districtEn: "District",
    rating: 4.5,
    price: 40000,
    numberOfStudents: 7000,
    images: [
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
    ],
    educationSystem: "النظام الفرنسي",
    educationSystemEn: "France system",
    educationLevel: "المتوسطة",
    educationLevelEn: "Medium",
    studentGender: "إناث",
    studentGenderEn: "Females",
    instagramAccount: "",
    xAccount: "",
    whatsapp: "",
    parentesReviwes: [
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
    ],
    schoolFeatures: ["غرفة موسيقى", "كافتيريا أو منطقة توزيع الوجبات"],
    schoolFeaturesEn: ["Music room", "Cafeteria or Meal Distribution Area"],
  },
  {
    id: 5,
    schoolName: "مدارس الأهلية",
    schoolNameEn: "National Schools",
    description:
      "نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة",
    descriptionEn:
      "About the school About the school About the school About the school About the school",
    country: "السعودية",
    countryEn: "Saudi Arabia",
    city: "جدة",
    cityEn: "Jeddah",
    district: "الحي",
    districtEn: "District",
    rating: 3.9,
    price: 15000,
    numberOfStudents: 1000,
    images: [
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
    ],
    educationSystem: "النظام الأمريكي",
    educationSystemEn: "American system",
    educationLevel: "كل المراحل",
    educationLevelEn: "All Levels",
    studentGender: "كلاهما",
    studentGenderEn: "Both",
    instagramAccount: "",
    xAccount: "",
    whatsapp: "",
    parentesReviwes: [
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
    ],
    schoolFeatures: ["غرفة موسيقى", "النظام البريطاني"],
    schoolFeaturesEn: ["Music room", "British System"],
  },
  {
    id: 6,
    schoolName: "مدارس النموذجية",
    schoolNameEn: "AlNamouthajiya school",
    description:
      "نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة نبذة موجزة عن المدرسة",
    descriptionEn:
      "About the school About the school About the school About the school About the school",
    country: "السعودية",
    countryEn: "Saudi Arabia",
    city: "الرياض",
    cityEn: "Riyadh",
    district: "الحي",
    districtEn: "District",
    rating: 4.9,
    price: 25000,
    numberOfStudents: 5000,
    images: [
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
      "/assets/images/placeholder.jpg",
    ],
    educationSystem: "النظام الفرنسي",
    educationSystemEn: "France system",
    educationLevel: "الثانوية",
    educationLevelEn: "High school",
    studentGender: "كلاهما",
    studentGenderEn: "Both",
    instagramAccount: "",
    xAccount: "",
    whatsapp: "",
    parentesReviwes: [
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
      {
        parentName: "أحمد خالد",
        review: "الطاقم الإداري والتعلمي على مستوى عالي من الكفاءة",
        rating: "",
        date: "March 14,2021 ",
      },
    ],
    schoolFeatures: ["غرفة موسيقى", "النظام البريطاني"],
    schoolFeaturesEn: ["Music room", "British System"],
  },
];
